export const testimonials = [
  {
    id: 1,
    name: 'Shrikanth Kurumathur',
    role: 'Strategic Technical Leader',
    content: 'The meditation sessions at Pragyavan have transformed my approach to stress management. The peaceful environment and expert guidance have helped me find inner balance that I never thought possible.',
    rating: 5,
    image: '/images/testimonials/shrikanth.jpeg',
    date: '2024-08-15',
    featured: true
  },
  {
    id: 2,
    name: 'Sharanya Venkatesh',
    role: 'Robotics Software Engineer',
    content: 'After months of searching for the right yoga practice, I found my home at Pragyavan. The personalized sessions and authentic teaching methods have greatly improved my physical and mental well-being.',
    rating: 5,
    image: '/images/testimonials/sharanya.jpeg',
    date: '2024-07-22',
    featured: true
  },
  {
    id: 3,
    name: 'Dr. Tina Damodar',
    role: 'Clinical Research Consultant, MD',
    content: 'As a healthcare professional, I appreciate the scientific approach combined with traditional wisdom at Pragyavan. The craniosacral therapy sessions have been incredibly effective for my patients and myself.',
    rating: 5,
    image: '/images/testimonials/tina.png',
    date: '2024-09-03',
    featured: true
  },
  {
    id: 4,
    name: 'Arjun Nair',
    role: 'Business Owner',
    content: 'The 1:1 personal sessions have been a game-changer for my wellness routine. The instructors truly understand individual needs and create a perfect balance of challenge and relaxation.',
    rating: 5,
    image: '/images/testimonials/arjun.jpg',
    date: '2024-06-18',
    featured: false
  },
  {
    id: 5,
    name: 'Kavya Reddy',
    role: 'Teacher',
    content: 'Pragyavan has become my sanctuary. The guided meditation sessions have helped me develop patience and mindfulness that I bring into my classroom every day.',
    rating: 5,
    image: '/images/testimonials/kavya.jpg',
    date: '2024-08-01',
    featured: false
  }
];

export const getFeaturedTestimonials = () => {
  return testimonials.filter(testimonial => testimonial.featured);
};

export const getAllTestimonials = () => {
  return testimonials.sort((a, b) => new Date(b.date) - new Date(a.date));
};

export const getTestimonialById = (id) => {
  return testimonials.find(testimonial => testimonial.id === id);
};